export default __webpack_public_path__ + "static/media/Disclaimer.cfde348e.pdf";